import { DialogTitle, DialogContent, DialogActions, Button, Box } from '@mui/material';
import { useState } from 'react';
import { WsButton, WsDialog, WsProfileImageSelector } from 'wisestep-base';

interface IUploadProfileImageDialog {
  open: boolean;
  handleClose: () => void;
  saveAction: (image: string) => void;
  removeDocument: () => void;
  disableSelectCatagory: boolean;
}
const UploadProfileImageDialog = ({
  open = false,
  handleClose,
  saveAction,
}: IUploadProfileImageDialog) => {
  const [croppedImage, setCroppedImage] = useState<string | null>(null);
  const [base64Img, setBase64Img] = useState<string | null>(null);

  const closeDialog = () => {
    setBase64Img(null);
    setCroppedImage(null);
    handleClose();
  };

  const handleCrop = async () => {
    base64Img && saveAction(base64Img);
    handleClose();
  };

  return (
    <Box>
      <WsDialog openDialog={open} onClose={closeDialog}>
        <DialogTitle>Upload & Crop Image</DialogTitle>
        <DialogContent>
          <WsProfileImageSelector
            placeholderText="Upload your profile picture"
            handleCrop={(croppedBase64) => setBase64Img(croppedBase64)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDialog}>Cancel</Button>
          {!croppedImage && (
            <WsButton variant="contained" onClick={handleCrop} disabled={!base64Img}>
              Confirm
            </WsButton>
          )}
        </DialogActions>
      </WsDialog>
    </Box>
  );
};

export default UploadProfileImageDialog;
